import { render } from "./StudentClassLeaveCheck.vue?vue&type=template&id=9ce45d60&scoped=true"
import script from "./StudentClassLeaveCheck.vue?vue&type=script&lang=js"
export * from "./StudentClassLeaveCheck.vue?vue&type=script&lang=js"

import "./StudentClassLeaveCheck.vue?vue&type=style&index=0&id=9ce45d60&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ce45d60"]])

export default __exports__